import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dots-loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
      return _createElementVNode("span", {
        class: _normalizeClass(["dot", { small: _ctx.small }]),
        key: n,
        style: _normalizeStyle({ animationDelay: `${(n - 1) * 0.2}s` })
      }, null, 6)
    }), 64))
  ]))
}